import { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { checkForUpdates, updateStoredVersion, getAppVersion } from '../lib/version';

export function VersionChecker() {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);

  useEffect(() => {
    const hasUpdate = checkForUpdates();

    if (hasUpdate) {
      console.log('[VersionChecker] New version detected, showing update notification');
      setShowUpdateNotification(true);
    } else {
      updateStoredVersion();
    }

    const intervalId = setInterval(() => {
      const hasUpdateNow = checkForUpdates();
      if (hasUpdateNow && !showUpdateNotification) {
        console.log('[VersionChecker] New version detected during periodic check');
        setShowUpdateNotification(true);
      }
    }, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [showUpdateNotification]);

  const handleRefresh = () => {
    console.log('[VersionChecker] User triggered refresh for new version');
    updateStoredVersion();

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.unregister());
      });
    }

    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }

    window.location.reload();
  };

  const handleDismiss = () => {
    console.log('[VersionChecker] User dismissed update notification');
    setShowUpdateNotification(false);
    updateStoredVersion();
  };

  if (!showUpdateNotification) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md bg-white border border-gray-200 rounded-lg shadow-lg p-4 animate-slide-up">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <AlertCircle className="w-6 h-6 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 mb-1">
            Update Available
          </h3>
          <p className="text-sm text-gray-600 mb-3">
            A new version (v{getAppVersion()}) is available. Please refresh to get the latest features and fixes.
          </p>
          <div className="flex gap-2">
            <button
              onClick={handleRefresh}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              Refresh Now
            </button>
            <button
              onClick={handleDismiss}
              className="px-4 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors"
            >
              Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
